define('plugin/client-login/view/ClientLoginRemindPasswordView',['require','lib/view/FormView'],function (require) {

    var FormView = require('lib/view/FormView');

    /**
     * Client remind password
     *
     * @class ClientLoginRemindPasswordView
     */
    return FormView.extend({

        template: '#client_login_remind_password',
        ui: {
            'remind_btn': '#sb_remind_btn',
            'inputs': ':input'
        },
        triggers: {
            'click @ui.remind_btn': 'remind'
        },
        modelEvents: {
            'invalid': 'render'
        },

        getDataToRemind: function () {
            return this._getData(this.ui.inputs);
        },

        serializeData: function () {
            return _.extend({
                'is_modal': this.getOption('isModal')
            }, this._serializeData());
        }

    });

});
